// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"89fb5a2b","156":"0f101fde","243":"0cb0a3aa","397":"93154d62","409":"8c960d01","453":"4206f2a5","498":"749edb28","880":"e59a811f","901":"0bb55edf"}[chunkId] + ".chunk.js";
};